export const profile = {
  name: "苍井樱",
  nameJa: "蒼井桜",
  nameEn: "Sakura Aoi",
  birthday: "1995-03-15",
  birthplace: "日本东京都",
  height: "162cm",
  measurements: "B88 W58 H86",
  bloodType: "A型",
  hobby: "瑜伽、旅行、料理",
  debut: "2015年",
  agency: "Sakura Production",
  bio: "苍井樱，日本知名艺人，2015年正式出道。凭借清纯甜美的外表与出色的表现力迅速走红，成为业界最具人气的艺人之一。她不仅在演艺事业上取得了卓越成就，还积极参与公益活动，多次获得业界大奖。苍井樱以其独特的个人魅力和专业素养，赢得了海内外众多粉丝的喜爱与支持。",
  bioExtended: "苍井樱出生于日本东京都，从小就对表演艺术充满热情。高中毕业后，她进入演艺圈，凭借出色的外形条件和扎实的演技功底，迅速崭露头角。多年来，她不断挑战自我，尝试不同类型的作品，展现出了惊人的演技广度和深度。除了演艺事业，苍井樱还热衷于瑜伽和旅行，经常在社交媒体上分享自己的生活点滴，与粉丝保持亲密互动。她的真诚与努力，让她在竞争激烈的演艺圈中始终保持着独特的地位。",
  awards: [
    { year: "2017", title: "最佳新人奖" },
    { year: "2018", title: "最受欢迎女艺人奖" },
    { year: "2019", title: "年度最佳表演奖" },
    { year: "2020", title: "粉丝选择大奖" },
    { year: "2022", title: "终身成就荣誉奖" },
  ],
  socialLinks: {
    twitter: "https://twitter.com/sakura_aoi",
    instagram: "https://instagram.com/sakura_aoi_official",
    youtube: "https://youtube.com/@sakura_aoi",
  },
};

export const siteInfo = {
  name: "苍井樱官方资料站",
  slogan: "全面了解苍井樱的中文资讯平台",
  description: "苍井樱个人资料、作品集、最新动态一网打尽。本站汇聚苍井樱详细档案、经典作品回顾、粉丝热议内容，是了解苍井樱最权威的中文资讯平台。",
  keywords: "苍井樱,苍井樱资料,苍井樱作品,苍井樱档案,苍井樱最新,苍井樱图片,日本女优",
  url: "https://aoi-sakura-info.example.com",
  foundingYear: "2020",
};